export default {
    startPage: {
        title: 'Vue 学习'
    },
    menu: {
        Documents: 'スポーツアーカイブ',
        Setting: 'システム設定',
        Applications: "テストシステム",
        Report: "分析レポート",
        AthleteDocuments: "運動選手",
        SportProject: "スポーツプロジェクト",
        Options: "基本設定",
        Permission: "権限管理",
        StandardData: "標準値管理",
        MuscleStrengthStandard: '携帯型筋力基準値',
        UserManagement: "人員管理",
        Subject: "運動選手詳細",
        Record: "個人記録",
        Result: "テスト結果",
        Actions: "動作データ",
        SportsPerformanceStandardData: 'スポーツ機能表現システム',
        MuscleStrengthStandardData: '携帯型筋力テストシステム'
    },
    userMenu: {
        confirmExit: 'ログアウト',
        confirmMsg: '本当にログアウトしますか?',
        DarkMode: 'ダークモード',
        Modify: 'プロフィール変更',
        Account: 'アカウント',
        UserName: 'ユーザー名',
    },
    options: {
        Title: '個人設定',
        Language: '言語',
        ModifyNotice: '変更成功',
        ModifyNotice2: '変更失敗',
        SystemSettings: '基本設定',
        AccountSetting: 'アカウント設定',
        Account: 'アカウント',
        OrganizationInfo: '組織情報',
        CompanyName: '会社名：',
        CompanyCode: '会社コード：',
        CustomLogo: 'カスタムロゴ',
        Name: '氏名',
        Preview: 'プレビュー',
        UploadPictures: 'クリックして画像をアップロード',
        Notice1: '画像の最適サイズは高さ48px、幅200px以内、サイズ1Mb未満、pngまたはjpg形式',
        ModifyPassword: 'パスワードリセット/変更',
        confirmExit: 'ログアウト',
        ModifyName: '氏名変更',
        notice2: '氏名変更成功',
        notice3: '氏名を入力してください',
        Lable: {
            Multilingual: '多言語',
            Logo: 'カスタムロゴ',
        }
    },
    login: {
        Label: {
            UserName: 'アカウント',
            Password: 'パスワード',
            Login: 'ログイン',
            Reset: 'リセット',
            Title: 'ログインしてください',
            Title2: '登録',
            Forget: 'パスワードを忘れましたか？',
            Remember: 'パスワードを保存する',
            Register: '登録へ>>',
            ToLogin: 'アカウントがある方はログインへ>>',
            Captche: '認証コードを取得',
            Retry: '再送信',
            Agree: '《ユーザー協定》に同意する',
            UserNamePlaceholde: 'ユーザー名を入力してください',
            PasswordPlaceholde: 'パスワードを入力してください',
            CompanyCodePlaceholder: '会社コード',
            MailBoxPlaceHolder: 'メールアドレスを入力してください',
            CaptchaPlaceholder: 'メール認証コード',
        },
        Message: {
            PasswordLength: 'パスワードの長さは8～16文字です',
            CaptchaSuccess: '送信成功',
            Agree: '《ユーザー協定》を読み、チェックしてください',
            AccountEmpty: 'メールアドレスを正しく入力してください',
            Registered: '登録成功',
            loginFaild: "ログインに失敗しました",
            Captcha: '認証コードの長さが足りません',
            CaptchaLenthL: '完全な認証コードを入力してください',
            CompanyCodeLength: '正しい会社コードを入力してください',
        }
    },
    forget: {
        Label: {
            Title: 'パスワード再設定',
            GoToLogin: 'ログインへ>>',
            Captche: '認証コードを取得',
            Reset: 'パスワードリセット',
            Retry: '再送信',
            Contact: 'このページで解決しない場合は、カスタマーサポートに連絡してください',
            AccountPlaceholder: 'ログイン用メールアドレスを入力してください',
            CaptchaPlaceholder: 'メール認証コード',
            PasswordPlaceholder: '新しいパスワード',
            ModifyPassword: 'パスワード変更',
        },
        Message: {
            CaptchaSuccess: '送信成功',
            ResetSuccess: 'パスワードリセット成功',
            AccountEmpty: 'メールアドレスを正しく入力してください',
        }
    },
    global: {
        HomePage: 'ホームページ',
        Loading: '読み込み中',
        CopySuccess: 'コピー成功',
        CopyFailed: 'コピー失敗',
        Refresh: '更新',
        Add: '追加',
        Create: '新規作成',
        Modify: '変更',
        Confirm: '確認',
        Cancel: 'キャンセル',
        Save: '保存',
        View: "表示",
        Edit: "編集",
        Delete: "削除",
        Finish: "完了",
        LastWeek: "直近1週間",
        LastMonth: "直近1ヶ月",
        Last3Month: "直近3ヶ月",
        StartDate: "開始日",
        EndDate: "終了日",
        TestProject: "テストプロジェクト",
        SportProject: "スポーツプロジェクト",
        None: "無制限",
        Gender: "性別",
        RequestFailed: 'リクエストに失敗しました!',
        ResponseFailed: 'レスポンスに失敗しました!',
        LoadSuccess: 'ダウンロード成功',
        LoadFailed: 'ダウンロード失敗',
        EditRelation: '運動関係を編集',
        EditSubject: '運動選手情報を編集',
        EditProject: 'スポーツプロジェクトを編集',
        Import: 'インポート',
        Export: 'エクスポート',
        NoneData: 'データなし',
        NoneRank: 'ランキングなし',
        SaveSuccess: "保存成功",
        Checked: '選択済み',
        Close: '閉じる',
    },
    Permission: {
        Label: {
            Title: "権限管理",
            Enable: "有効化",
            Description: "説明",
            ExpireDate: "有効期限",
            CreateGroup: "グループ作成",
            GroupRole: "役割タイプ",
            GroupName: "役割名",
            SelectRoleType: "役割タイプを選択",
        },
        Message: {
            GetGroupsFailed: "グループの取得に失敗しました",
            GetApplicationListFailed: "アプリケーションリストの取得に失敗しました",
            ChangeUnsaved: "未保存の変更があります。本当に離開しますか?",
            ComfirmToDelete: "このグループを削除しますか?",
            DeleteSuccess: "グループ削除成功",
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: '個人アーカイブを表示',
            InvationInfo: 'ユーザー登録招待情報',
            DeleteInvation: '招待を削除',
            ViewHistoryRecords: '履歴を表示',
            ViewDetailRecords: '記録詳細を表示',
            TestDetialExport: '記録詳細エクスポート',
            ViewActionDetail: 'アクション詳細を表示',
            ActionDataExport: 'アクションデータエクスポート',
        },
        HomePage: 'ホームページ',
        Reinvite: '再招待',
        SportDocuments: 'スポーツアーカイブ',
        RegisterSubject: {
            Title: 'プロフィールを完善してください',
            Save: 'プロフィールを提出',
            From: 'から',
            Invitation: '招待',
            PlaseEnter: '入力してください',
        },
        Athletes: {
            TotalCount: '現在合計',
            TotalProjects: '個のプロジェクト',
            DeleteNotice: '情報入力招待中の運動選手を削除しますか?',
            ProjectNameSearch: 'スポーツプロジェクト名での検索に対応',
            selectDate: '日付を選択',
            CreateTime: '作成時間',
            ClickShow: 'クリックして展開',
            ClickPutaway: 'クリックして収起',
            FormarErrorNotice: '(注意:小数点以下1桁まで保持可能)',
            EmailNoticeLogin: 'メールアドレス(ログインに使用可能)',
            LoginEmail: 'ログインに使用可能',
            Athletes: '運動選手',
            MultipleSelection: '複数選択',
            true: '複数選択',
            false: '完了',
            AddDocuments: 'アーカイブを追加',
            TestSystem: 'テストシステム(単一選択)',
            Nodata: 'データなし',
            SportFunction: 'スポーツ機能表現テストシステム',
            DigitalRunway: 'デジタルランウェイデータ収集分析ソフトウェア',
            MuscleStrength: '筋力テストシステム',
            GolfTechnique: 'ゴルフ技術診断',
            Screening: '絞り込み',
            GenderLimit: '性別無制限',
            SystemLimit: 'システム無制限',
            TestProject: 'テストプロジェクト',
            Photo: '写真',
            NextPage: '次のページ',
            PreviousPage: '前のページ',
            Age: '年齢',
            View: '表示',
            EditingData: 'プロフィール編集',
            HistoricalRecord: '履歴',
            SkipPages: 'ページジャンプ',
            AddTestProject: '+テストプロジェクトに追加',
            AssociationSportProject: '+スポーツプロジェクトを関連付け',
            DeldeteDocument: 'アーカイブを削除',
            Complete: '完了',
            SearchNotice: '氏名での検索に対応',
            CreateSubject: '新規アーカイブ作成',
            ModifySubject: 'アーカイブを変更',
            AddRelationSuccessNotice: '関連付け成功',
            AddRelationFailNotice: '関連付け失敗',
            AddRelationNotice: '関連付けるプロジェクトを選択してください',
            BaseInfo: '基本情報',
            InviteUsersRegister: 'ユーザー登録招待',
            Save: '保存',
            Total: '合計',
            Projects: '個のプロジェクトがすべて',
            Picture: '写真',
            PhotoLimitNotice: '写真は1M以内',
            PhotoLimitNotice2: '写真をアップロードしてください（1M以内）',
            Name: '氏名',
            EnterNotice: '運動選手の氏名を入力してください',
            Gneder: '性別',
            Birthday: '誕生日',
            Height: '身長',
            Weight: '体重',
            EnterWeightNotice: '運動選手の体重を入力してください',
            EnterHeightNotice: '運動選手の身長を入力してください',
            PhoneNumber: '電話番号',
            EnterPhoneNumberNotice: '電話番号を入力してください',
            RequiredNotice: '必須項目',
            PhoneNumberNotice: '正しい電話番号形式を入力してください',
            Email: 'メールアドレス',
            EnterEmailNotice: 'メールアドレスを入力してください',
            EmailNotice: '正しいメールアドレス形式を入力してください',
            PictureFileNotice: '正しい画像ファイルを選択してください',
            PictureSizeNotice: '画像は1M未満を選択してください',
            Manage: '管理',
            Add: '+追加',
            Years: '歳',
            FormarError: 'データ形式が不正です',
            ViewDocument: 'アーカイブを表示',
            AddToProject: 'プロジェクトに追加',
            Record: '記録',
            LoadAll: 'すべてのリソースを読み込みました',
            Reset: 'リセット',
            Invationing: '招待記録',
            BatchExportIndicator: 'バッチエクスポート指標',
            BatchExportRawData:'元データ一括出力',
            Link: {
                Invitation: 'ユーザー登録招待',
                FileName: 'アーカイブ氏名',
                LoginEmail: '登録メールアドレス',
                InvitationLink: '招待リンク',
                SendInvitation: '招待を送信',
                CopyLink: 'リンクをコピー',
                LinkNotice: 'ユーザーが資料を提出してからアーカイブ作成が完了します',
                InvitationOther: '他のユーザーを招待',
                Notice: 'コピー成功',
                Notice2: 'コピー失敗',
                Notice3: '招待送信成功',
                Notice4: '招待送信失敗',
                InvationNotice: '運動選手の氏名を入力し、リンク生成ボタンをクリックすると、招待リンクが入力したメールアドレスに直接送信されます',
                Notice5: '運動選手名を入力してください',
            },
            Details: {
                RelationToProject: 'プロジェクトに追加',
                ModifySocument: 'プロフィール編集',
                RelationRecord: '関連記録',
                None: '無',
                SwingSide: 'バッター',
                PowerLeg: '発力脚',
                LeftHand: '左手',
                RightHand: '右手',
                LeftLeg: '左腿',
                RightLeg: '右腿',
                Left: '左',
                Right: '右',
                LeftRight: '左右',
                ShoeSize: '靴サイズ',
                Statistics: 'データ統計',
                ClickNotice: 'アクションまたは数字をクリックして詳細を表示',
                Unit: {
                    SwingSide: '手',
                    PowerLeg: '脚',
                    ShoeSize: 'サイズ',
                }
            },
            TestRecord: {
                TestRecord: 'テスト記録',
                StartDate: '開始日',
                EndDate: '終了日',
                SelectNotice: '先にテストシステムを選択してください',
                Time: '時間',
                None: '無',
                DataLength: '件の記録',
            },
            Result: {
                Application8: {
                    'Swing': '腕振り',
                    'Akimbo': '腰を組む',
                    'Other': 'その他',
                    'Bilateral': '両側',
                    'Left': '左側',
                    'Right': '右側',
                    'MidThighPull': '大腿中央硬拉',
                    '1_4Squat': '1/4スクワット',
                    'CalfRaise': '踵上げ',
                    'Customization': 'カスタマイズ',
                    'ITest': 'Iテスト',
                    'YTest': 'Yテスト',
                    'TTest': 'Tテスト',
                    'FreeMode': 'フリーモード',
                    'TimekeepingMode': '計時モード',
                    'UpperLimbs': '上肢',
                    'LowerLimbs': '下肢',
                    '力': '力',
                    '时间': '時間',
                    '速度/加速度': '速度/加速度',
                    '功率': 'パワー',
                    '位移': '変位',
                    '其他': 'その他',
                    '冲量': 'インパルス',
                    '频率': '頻率',
                    'Remark': '備考',
                    '': '',
                    'ImportantLeftRightRatio': '重点の左右分量',
                    'OtherLeftRightRatio': 'その他の左右分量',
                    'ArmWeight': '腕の重量'
                },
                SendNotice: '送信する内容を選択してください',
                SendSuccessfully: '送信成功',
                EmailContent: 'メール内容',
                SendEmail: 'メールを送信',
                ReceivingEmail: '受信メールアドレス',
                COPPosition: 'COP',
                ModelSetting: 'モジュール設定',
                ModelType: 'テストモジュール',
                L_Fz_COP: 'L-COP 連線',
                R_Fz_COP: 'R-COP 連線',
                Fz_COP: '合力-COP 連線',
                Left: '左',
                Right: '右',
                Fz: '合力',
                COP: 'COPビュー',
                AllFz: '合力-Fz',
                Legend: '凡例',
                Asi: '非対称指数',
                LeftRightRatio: '左-右比率',
                HistoryMax: '歴史最高',
                Now: '現在',
                MainIndicators: '主要指標',
                OtherIndicators: 'その他指標',
                ExtendedIndicators: '拡張指標',
                SingleView: '単発指標',
                NumberOfTimes: '回数',
                NoData: '未保存データ',
                GoBack: '戻る',
                RawData: "原始記録をダウンロード",
                Export: '指標をエクスポート',
                Weight: 'テスト体重',
                Duration: 'テスト所要時間',
                GolfClubs: '使用クラブ',
                Spacing: 'スタンス間隔',
                LeftAngle: '左偏角',
                RightAngle: '右偏角',
                LeftLeg: '左脚',
                RightLeg: '右脚',
                ResultantForce: '合力',
                Limbs: '体幹',
                Side: '部位',
                Actions: 'アクション',
                Pose: 'ポーズ',
                Order: '順序',
                Joint: '関節',
                KneePosition: '膝の位置',
                Times_L: '左脚回数',
                Times_R: '右脚回数',
                0: 'デフォルト',
                1: '左側',
                2: '右側',
                3: '左→右',
                4: '右→左',
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: '第T回',
                ExportReport: 'レポートをエクスポート',
                Repetitions: '繰り返し回数',
                ContainsPersonalRecords: '個人記録を含みます',
                MuscleStrengthAvgIndicator: {
                    最大峰值力: '最大ピーク力',
                    平均峰值力: '平均ピーク力',
                    到达峰值时间: 'ピーク到達時間',
                    峰值发力率: 'ピーク発力率',
                    峰值力: 'ピーク力',
                },
                '左侧最大范围': '左側最大範囲',
                '左侧最大范围时间': '左側最大範囲時間',
                '右侧最大范围': '右側最大範囲',
                '右侧最大范围时间': '右側最大範囲時間',
                '左侧平均范围': '左側平均範囲',
                '最大范围BSA': '最大範囲BSA',
                '右侧平均范围': '右側平均範囲',
                '最大范围': '最大範囲',
                '平均范围': '平均範囲',
                '最大范围时间': '最大範囲時間',
                Times: '次',
                NumberOfTests: 'テスト回数',
                LeftSide: '左側',
                RightSide: '右側',
                数值: "数値",
                ReferenceValue: '基準値',
                Internal: '内旋',
                External: '外旋',
                Adduction: '内転',
                Abduction: '外転',
                Varus: '内反',
                Valgus: '外反',
                MaximumForceRatio: '最大力値比',
                AvgForce: 'ピーク力平均値',
                MaxForce: 'ピーク力最大値',
                MaxImpulse: '最大インパルス',
                AvgImpulse: '平均インパルス',
                AvgForce_Baseline: 'ピーク力平均値（基線値）',
                MaxForce_Baseline: 'ピーク力最大値（基線値）',
                MaxImpulse_Baseline: '最大インパルス（基線値）',
                AvgImpulse_Baseline: '平均インパルス（基線値）',
            },
            Action: {
                Action: 'アクションデータ',
                TrendChart: 'トレンドチャート',
                IndexNotice: '閲覧する指標を選択してください',
                RelationRecord: '関連記録',
                Delete: '削除',
                Export: '選択した記録をエクスポート',
                None: '無',
                ExportData: '原始データをエクスポート',
                ExportData1: 'データをエクスポート',
                EcportIndex: '指標をエクスポート',
                ExportReport: 'レポートをエクスポート',
                C3DReport: 'C3Dをエクスポート',
                ViewRecord: '記録を閲覧',
                Index: '指標',
                Report: 'レポート',
                Data: '原始データ',
                Total: '合計',
                Datas: '件のデータ',
                Max: '最大値',
                Min: '最小値',
                Notice: '先に記録を選択してください',
                NoIndex: '指標なし',
            },
            SingleCreate: '手動で追加',
            DownloadTemplate: 'インポートテンプレートをダウンロード',
            SubjectImportTemplate: "被験者インポートテンプレート",
            ImportFromTemplate: 'テンプレートバッチインポート',
            Template: '運動選手バッチインポートテンプレート',
            Upload: 'インポート',
            ImportSuccess: 'インポート成功',
            ImportFailed: 'インポート失敗',
            Items: '項目',
        },
        SportProjects: {
            SportProjects: 'スポーツプロジェクト',
            AddSportProjectNotice: 'スポーツプロジェクトは運動選手を区別するためのみ使用されます',
            ProjectName: 'プロジェクト名',
            AddProject: 'プロジェクトを追加',
            RelatedCount: '関連人数',
            Operate: '操作',
            RelatedAthletes: '関連する運動選手',
            AddSportProject: 'スポーツプロジェクトを追加',
            notice1: '少なくとも1つ選択してください',
            SelectApplications: 'アプリケーションシステム',
            ProNameNotice: 'スポーツプロジェクト名を入力してください',
            addSuccessNotice: 'スポーツプロジェクトの追加に成功しました',
            addFaildNotice: 'スポーツプロジェクトの追加に失敗しました',
            deleteSuccessNotice: 'スポーツプロジェクトの削除に成功しました',
            deleteFaildNotice: 'スポーツプロジェクトの削除に失敗しました',
            updateSuccessNotice: 'スポーツプロジェクトの変更に成功しました',
            updateFaildNotice: 'スポーツプロジェクトの変更に失敗しました',
            CreateSportProject: 'スポーツプロジェクト作成',
            EmptyNotice: 'プロジェクト名を入力してください',
            People: '人',
            Name: '氏名',
            Gender: '性別',
            Birthday: '誕生日',
            ModifyName: '変更',
            ModifySportProject: 'スポーツプロジェクトを変更',
            modifySuccessNotice: 'プロジェクト名の変更に成功しました',
            modifyFaildNotice: 'プロジェクト名は重複できません',
            AddSport: '運動選手の管理',
            Athletes: '運動選手',
            QueryError: '検索に失敗しました',
            Added: '追加済み',
            SaveFailNotice: '保存に失敗しました',
            SaveSuccessNotice: '保存に成功しました',
            NotSaved: '内容が保存されていません。離開しますか？',
            DeleteNotice: 'このスポーツプロジェクトを削除しますか？',
            Notice: '提示',
            DeleteProjcctNotice: 'スポーツプロジェクトの削除',
        }
    },
    Application: {
        Name: {
            1: '筋力テストシステム',
            5: 'ゴルフ技術診断システム',
            6: 'ハムストリングステストシステム',
            7: '多機能測力架',
            8: 'スポーツ機能表現テストシステム',
            9: '関節可動域',
        },
        Label: {
            Detail: "詳細を表示",
            SubjectCount: '運動選手',
            RecordCount: 'テスト記録',
            ProjectCount: 'テストプロジェクト',
            RankList: "ランキング表示",
            More: "もっと>",
            TrendCharts: "テストトレンド",
            Indicators: "指標を表示",
            ExportIndicators: "指標をエクスポート",
            TrainingPlan: 'トレーニングプラン',
            MostRecentRecord: '最新の記録',
            AllRecords: 'すべての記録',
        },
        Options: {
            LastDays: "直近%d日"
        },
        Columns: {
            CreateTime: '作成時間'
        },
    },
    Report: {
        Label: {
            MinAvgMax: '最小/最大',
            ReportChart: 'データレポートチャート',
            Query: '絞り込み',
            Export: 'エクスポート',
            IndicatorOptions: '指標絞り込み',
            SubjectOptions: '運動選手を選択',
            MaxValue: '最大値を取得',
            MinValue: '最小値を取得',
            InsertChart: 'チャート追加',
            ModifyChart: 'チャート変更',
            true: '最大値を取得',
            false: '最小値を取得',
            指标: '指標',
            值: '値',
            单位: '単位'
        },
        Message: {
            IndicatorsEmpty: '指標を選択してください',
            SubjectEmpty: '運動選手を選択してください',
        },
        Indicators: {
            峰值: 'ピーク',
            峰值时间: 'ピーク時間',
            最大发力率: '最大発力率',
            最大峰值力: '最大ピーク力',
            平均峰值力: '平均ピーク力',
            到达峰值时间: 'ピーク到達時間',
            峰值发力率: 'ピーク発力率',
            左脚平均峰值力: '左脚平均ピーク力',
            右脚平均峰值力: '右脚平均ピーク力',
            左脚最大力值: '左脚最大力値',
            右脚最大力值: '右脚最大力値',
            左脚重复次数: '左脚回数',
            右脚重复次数: '右脚回数',
            左重复次数: '左回数',
            右重复次数: '右回数',
            内收左重复次数: '内転左回数',
            内收右重复次数: '内転右回数',
            外展左重复次数: '外転左回数',
            外展右重复次数: '外転右回数',
            内旋左重复次数: '内反左回数',
            内旋右重复次数: '内反右回数',
            外旋左重复次数: '外反左回数',
            外旋右重复次数: '外反右回数',
            内翻左重复次数: '内反左回数',
            内翻右重复次数: '内反右回数',
            外翻左重复次数: '外反左回数',
            外翻右重复次数: '外反右回数',
            左最大力值: '左最大力値',
            右最大力值: '右最大力値',
            内收左最大力值: '内転左最大力値',
            内收右最大力值: '内転右最大力値',
            外展左最大力值: '外転左最大力値',
            外展右最大力值: '外転右最大力値',
            内旋左最大力值: '内反左最大力値',
            内旋右最大力值: '内反右最大力値',
            外旋左最大力值: '外反左最大力値',
            外旋右最大力值: '外反右最大力値',
            内翻左最大力值: '内反左最大力値',
            内翻右最大力值: '内反右最大力値',
            外翻左最大力值: '外反左最大力値',
            外翻右最大力值: '外反右最大力値',
            左脚扭矩: '左脚トルク',
            右脚扭矩: '右脚トルク',
            左脚峰值力最大值: '左脚ピーク力最大値',
            右脚峰值力最大值: '右脚ピーク力最大値',
            峰值力最大值BSA: 'ピーク力最大値BSA',
            左脚峰值力平均值: '左脚ピーク力平均値',
            右脚峰值力平均值: '右脚ピーク力平均値',
            峰值力平均值BSA: 'ピーク力平均値BSA',
            左脚冲量平均值: '左脚インパルス平均値',
            右脚冲量平均值: '右脚インパルス平均値',
            冲量平均值BSA: 'インパルス平均値BSA',
            左脚冲量最大值: '左脚インパルス最大値',
            右脚冲量最大值: '右脚インパルス最大値',
            冲量最大值BSA: 'インパルス最大値BSA',


            'Absolute': '絶対値',
            'Relative': '相対値',
            'LeftComponent': '左',
            'RightComponent': '右',
            '缓冲最小力值': '最小アンウェイト力',
            '制动最大力值': '制動最大力',
            '蹬伸最大力值': '推進最大力值',
            '落地最大力值': '最大着地力',
            '离心制动阶段发力率': '制動局面の力発揮率(RFD)',
            '制动最大力值发力率': '推進局面の力発揮率(RFD)',
            '蹬伸平均功率': '平均推進パワー',
            '蹬伸峰值功率': '最大推進パワー',
            '离心制动阶段冲量': '制動インパルス',
            '向心阶段净冲量': '向心性インパルス',
            '下蹲时间': '伸張性時間',
            '制动时间': '制動時間',
            '蹬伸时间': '推進時間',
            '蹬伸与制动时间比': '推進／制動時間比',
            '峰值功率发生时刻': 'ピークパワー到達時間',
            '触地时间': '離地までの時間',
            '腾空时间': '滞空時間',
            '落地稳定时间': '安定化時間',
            '下蹲平均速度': '平均伸張性速度',
            '离心阶段峰值速度': '最大伸張性速度',
            '向心阶段最大速度': '最大向心性速度',
            '峰值功率发生时速度': 'ピークパワー時速度',
            '起跳速度': '離地速度',
            '腾空高度Hv': 'ジャンプ高（v）',
            '腾空高度': 'ジャンプ高',
            '腾空高度Ht': 'ジャンプ高（t）',
            '腾空高度HFt': 'ジャンプ高（ft）',
            '下蹲深度': '沈み込み深度',
            '反应力量指数RSI': 'RSI',
            '反应力量指数RSImod': '修正RSI',
            '动态力量指数DSI': 'DSI',
            '左侧动态力量指数DSI': 'DSI（左）',
            '右侧动态力量指数DSI': 'DSI（右）',
            '离心利用率EUR': 'EUR',
            '预拉伸增强百分比PSAP': 'PSAP',
            '弹性指数ESI': 'ESI',
            '落地表现指数': '着地パフォーマンス指数',
            '最大蹬伸力发力率': '最大力発揮率(RFD)',
            '跌落峰值力': '最大制動力',
            '左侧跌落峰值力': '最大制動力（左）',
            '右侧跌落峰值力': '最大制動力（右）',
            '蹬伸峰值力': '最大推進力',
            '跌落峰值力加载率': '制動局面の力発揮率(RFD)',
            '左侧跌落峰值力加载率': '制動局面の力発揮率（左）',
            '右侧跌落峰值力加载率': '制動局面の力発揮率（右）',
            '蹬伸峰值力发力率': '推進局面の力発揮率(RFD)',
            '离心阶段冲量': '伸張性インパルス',
            '跌落峰值力到达时间': '最大着地力到達時間',
            '左侧跌落峰值力到达时间': '最大着地力到達時間（左）',
            '右侧跌落峰值力到达时间': '最大着地力到達時間（右）',
            '蹬伸峰值加速度': '最大推進加速度',
            '绝对最大力值': '最大力',
            '单位体重最大力值': '相対最大力',
            '左侧最大力值': '最大力（左）',
            '右侧最大力值': '最大力（右）',
            '50ms发力率': 'RFD(50ms)',
            '100ms发力率': 'RFD(100ms)',
            '150ms发力率': 'RFD(150ms)',
            '200ms发力率': 'RFD(200ms)',
            '250ms发力率': 'RFD(250ms)',
            '300ms发力率': 'RFD(300ms)',
            '50ms冲量': 'インパルス(50ms)',
            '100ms冲量': 'インパルス(100ms)',
            '150ms冲量': 'インパルス(150ms)',
            '200ms冲量': 'インパルス(200ms)',
            '250ms冲量': 'インパルス(250ms)',
            '300ms冲量': 'インパルス(300ms)',
            '到达最大力值时间': '最大力到達時間',
            '左侧到达最大力值时间': '最大力到達時間（左）',
            '右侧到达最大力值时间': '最大力到達時間（右）',
            '平均缓冲最大力值': '平均最大制動力',
            '平均蹬伸最大力值': '平均最大推進力',
            '平均缓冲最大力值加载率': '平均制動RFD',
            '平均缓冲时间': '平均制動時間',
            '平均蹬伸时间': '平均推進時間',
            '平均触地时间': '平均離地時間',
            '平均腾空时间': '平均滞空時間',
            '平均起跳速度': '平均離地速度',
            '平均腾空高度': '平均ジャンプ高',
            '平均蹬伸功率': '平均推進パワー',
            '平均蹬伸峰值功率': '平均最大推進パワー',
            '平均下蹲速度': '平均伸張性速度',
            '平均下蹲深度': '平均沈み込み深度',
            '缓冲最大力值': '最大制動力',
            '缓冲最大力值加载率': '制動RFD',
            '蹬伸功率': '推進パワー',
            '缓冲时间': '制動時間',
            '下蹲速度': '伸張性速度',
            '蹲起时间': 'スクワット時間',
            '下蹲和蹬伸时间比': '伸張／推進時間比',
            '平均击打峰值力': '平均タッピング最大力',
            '平均击打时间': '平均接地時間',
            '平均撤离时间': '平均滞空時間',
            '频率': '周波数',
            '初段平均频率': '平均周波数（初期局面）',
            '中段平均频率': '平均周波数（中間局面）',
            '末段平均频率': '平均周波数（終末局面）',
            '最小自由频率': '最小周波数',
            '最大自由频率': '最大周波数',
            '总计次数': '反復回数',
            '耐力指数': '持久力指数',
            '疲劳指数': '疲労指数',
            '落地峰值力': '最大着地力',
            '左侧落地峰值力': '最大着地力（左）',
            '右侧落地峰值力': '最大着地力（右）',
            '落地峰值力加载率': '着地RFD',
            '左侧落地峰值力加载率': '着地RFD（左）',
            '右侧落地峰值力加载率': '着地RFD（右）',
            '落地峰值力到达时间': '最大着地力到達時間',
            '左侧落地峰值力到达时间': '最大着地力到達時間（左）',
            '右侧落地峰值力到达时间': '最大着地力到達時間（右）',
            '落地到恢复稳定时间': '安定化時間',
            '触地时间差': '接地時間差',
            '左右摇晃速度': 'CoP速度（左右）',
            '前后摇晃速度': 'CoP速度（前後',
            '总体摇晃速度': 'CoP速度',
            '左右晃动幅度': 'CoP移動範囲（左右）',
            '前后晃动幅度': 'CoP移動範囲（前後）',
            '左右摇晃幅度': 'CoP移動範囲（左右）',
            '前后摇晃幅度': 'CoP移動範囲（前後）',
            '落地顺序': '着地シーケンス',
            '左右平均摇晃速度': 'CoP速度（左右）',
            '前后平均摇晃速度': 'CoP速度（前後）',
            '总体平均摇晃速度': '平均CoP速度',
            '左右摇晃轨迹长度': 'CoP移動距離（左右）',
            '前后摇晃轨迹长度': 'CoP移動距離（前後）',
            '总体摇晃轨迹长度': '総CoP移動距離',
            '左右摇晃最大幅度': 'CoP移動範囲（左右）',
            '前后摇晃最大幅度': 'CoP移動範囲（前後）',
            '轨迹包络面积': 'CoP動揺面積',
            '最大净力值': '最大力',
            '最大力值': '最大力',
            '最小力值': '最小力',
            '平均力': '平均力',
            '冲量': 'インパルス',
            '上箱高度Ht': '目標高さ',
            '平均反应力量指数RSI': '平均RSI',
            '缓冲最小力值分量': '最小アンウェイト力 - 左/右',
            '制动最大力值分量': '制動最大力 - 左/右',
            '蹬伸最大力值分量': '推進最大力值 - 左/右',
            '落地最大力值分量': '最大着地力 - 左/右',
            '离心制动阶段发力率分量': '制動局面の力発揮率(RFD) - 左/右',
            '制动最大力值发力率分量': '推進局面の力発揮率(RFD) - 左/右',
            '蹬伸平均功率分量': '平均推進パワー - 左/右',
            '蹬伸峰值功率分量': '最大推進パワー - 左/右',
            '离心制动阶段冲量分量': '制動インパルス - 左/右',
            '向心阶段净冲量分量': '向心性インパルス - 左/右',
            '最大蹬伸力发力率分量': '最大力発揮率(RFD) - 左/右',
            '跌落峰值力分量': '最大制動力 - 左/右',
            '蹬伸峰值力分量': '最大推進力 - 左/右',
            '跌落峰值力加载率分量': '制動局面の力発揮率(RFD) - 左/右',
            '蹬伸峰值力发力率分量': '推進局面の力発揮率(RFD) - 左/右',
            '离心阶段冲量分量': '伸張性インパルス - 左/右',
            '绝对最大力值分量': '最大力 - 左/右',
            '单位体重最大力值分量': '相対最大力 - 左/右',
            '50ms发力率分量': 'RFD(50ms) - 左/右',
            '100ms发力率分量': 'RFD(100ms) - 左/右',
            '150ms发力率分量': 'RFD(150ms) - 左/右',
            '200ms发力率分量': 'RFD(200ms) - 左/右',
            '250ms发力率分量': 'RFD(250ms) - 左/右',
            '300ms发力率分量': 'RFD(300ms) - 左/右',
            '50ms冲量分量': 'インパルス(50ms) - 左/右',
            '100ms冲量分量': 'インパルス(100ms) - 左/右',
            '150ms冲量分量': 'インパルス(150ms) - 左/右',
            '200ms冲量分量': 'インパルス(200ms) - 左/右',
            '250ms冲量分量': 'インパルス(250ms) - 左/右',
            '300ms冲量分量': 'インパルス(300ms) - 左/右',
            '平均缓冲最大力值分量': '平均最大制動力 - 左/右',
            '平均蹬伸最大力值分量': '平均最大推進力 - 左/右',
            '平均缓冲最大力值加载率分量': '平均制動RFD - 左/右',
            '平均蹬伸功率分量': '平均推進パワー - 左/右',
            '平均蹬伸峰值功率分量': '平均最大推進パワー - 左/右',
            '缓冲最大力值分量': '最大制動力 - 左/右',
            '平均击打峰值力分量': '平均タッピング最大力 - 左/右',
            '平均击打时间分量': '平均接地時間 - 左/右',
            '平均撤离时间分量': '平均滞空時間 - 左/右',
            '落地峰值力分量': '最大着地力 - 左/右',
            '落地峰值力加载率分量': '着地RFD - 左/右',
            '最大力值分量': '最大力 - 左/右',
            '最小力值分量': '最小力 - 左/右',
            '平均力分量': '平均力 - 左/右',
            '冲量分量': 'インパルス - 左/右',
            '动态反弹指数DRI': '動的反発係数（DRI）',
            '平均反应力量指数RSImod': '平均修正RSI',
            '': ''
        }
    },
    UserManagement: {
        Label: {
            Member: 'メンバー',
            Disabled: '無効化されたユーザー',
            SelectRole: 'ロールを選択',
            SelectGroup: '権限グループを選択',
            FilterByAccountName: 'アカウント名またはユーザー名でフィルター',
            BatchOperate: 'バッチ処理',
            CreateAccount: '新規ユーザーを追加',
            Enanble: 'ユーザーを有効化',
            Disable: 'ユーザーを無効化',
            Delete: '完全に削除',
            Permission: '権限',
            Information: 'プロフィールを変更',
            Role: 'ロール',
            PermissionGroup: '権限グループ',
            DefaultGroup: 'デフォルトグループ',
            Account: 'アカウント',
            Password: 'パスワード',
            Name: '氏名',
            ModifyPermission: 'ユーザー権限を変更',
            ModifyAccountInfo: 'ユーザー情報を変更',
            Prev: '前のページ',
            Next: '次のページ',
            CreateConfirm: 'ユーザー作成の確認',
        },
        Columns: {
            AvatarAccount: 'アバター/アカウント',
            UserName: 'ユーザー名',
            CreateTime: '作成時間',
            RolePermission: 'ロール/権限',
            Operate: '操作',
        },
        Message: {
            LengthNotice: '8文字から16文字で入力してください',
            AccountFillNotice: 'パスワードはメールアドレス形式です',
            ConfirmDisable: '当該ユーザーを無効化しますか？',
            ConfirmEnable: '当該ユーザーを有効化しますか？',
            ConfirmDelete: '当該ユーザーを完全に削除しますか？',
            ConfirmPermissionModify: '当該ユーザーの権限を変更しますか？',
            ConfirmModifyAccountInfo: '保存しますか？',
            PermissionModifySuccess: '権限変更に成功しました',
            PWNotice: 'パスワードは空欄にできません',
            NameNotice: '氏名は空欄にできません',
        }
    },
    Role: {
        0: '運動選手',
        1: 'コーチ',
        63: '管理者',
        127: '運用担当者',
        255: 'スーパー管理者',
        Subject: '運動選手',
        Coach: 'コーチ',
        Admin: '管理者',
        OM: '運用担当者',
    },
    Gender: {
        0: '男',
        1: '女',
        2: 'その他'
    },
    ActionModel: {
        RecordCount: '記録数',
        ProjectCount: 'プロジェクト数',
        Nordic: '北欧式',
        Razor: 'カミソリ式',
        IsometricContraction_0: '0°等尺性収縮',
        IsometricContraction_30: '30°等尺性収縮',
        IsometricContraction_60: '60°等尺性収縮',
        Irons: "アイアン",
        Woods: "ウッド",
        Wedges: "ウェッジ",
        Hybrids: "ハイブリッド",
        Putter: "パター",
        Iron1: "1番アイアン",
        Iron2: "2番アイアン",
        Iron3: "3番アイアン",
        Iron4: "4番アイアン",
        Iron5: "5番アイアン",
        Iron6: "6番アイアン",
        Iron7: "7番アイアン",
        Iron8: "8番アイアン",
        Iron9: "9番アイアン",
        Iron10: "10番アイアン",
        Driver: "ドライバー",
        Wood3: "3番ウッド",
        Wood5: "5番ウッド",
        Wood7: "7番ウッド",
        Wood9: "9番ウッド",
        Pitch: "ピッチ",
        Wedge48: "48°ウェッジ",
        Wedge50: "50°ウェッジ",
        Wedge52: "52°ウェッジ",
        Wedge54: "54°ウェッジ",
        Wedge56: "56°ウェッジ",
        Wedge58: "58°ウェッジ",
        Wedge60: "60°ウェッジ",
        Wedge62: "62°ウェッジ",
        Hybrid1: "1番ハイブリッド",
        Hybrid2: "2番ハイブリッド",
        Hybrid3: "3番ハイブリッド",
        Hybrid4: "4番ハイブリッド",
        Hybrid5: "5番ハイブリッド",
        Hybrid6: "6番ハイブリッド",
        Hybrid7: "7番ハイブリッド",
        '1': '首元',
        '2': '前屈',
        '3': '後仰',
        '4': '左屈',
        '5': '右屈',
        '6': '座姿',
        '7': '座姿',
        '8': '座姿',
        '9': '座姿',
        '10': '肩部',
        '11': '左側',
        '12': '右側',
        '13': '内旋',
        '14': '外旋',
        '15': '内収',
        '16': '外展',
        '17': '前屈',
        '18': '後伸',
        '19': 'ISO Iテスト',
        '20': 'ISO Yテスト',
        '21': 'ISO Tテスト',
        '22': '座位-肘部90°屈曲',
        '23': '座位-肘部90°屈曲・肩外展90°',
        '24': '立位-肘部90°',
        '25': '立位-肘部90°屈曲・肩外展90°・肩外旋90°',
        '26': '仰臥位-肘部90°屈曲・肩外展90°',
        '27': '仰臥位-肘部90°屈曲',
        '28': '俯臥位',
        '29': '座位-肘部90°屈曲',
        '30': '座位-肘部90°屈曲・肩外展90°',
        '31': '立位-肘部90°屈曲',
        '32': '立位-肘部90°屈曲・肩外展90°',
        '33': '仰臥位-肘部90°屈曲・肩外展90°',
        '34': '仰臥位-肘部90°屈曲',
        '35': '俯臥位',
        '36': '座位',
        '37': '立位',
        '38': '座位',
        '39': '立位',
        '40': '横臥位',
        '41': '座位-肩部外展90°',
        '42': '立位',
        '43': '立位-肘部90°屈曲',
        '44': '座位',
        '45': '立位',
        '46': '座位-肩部90°屈曲',
        '47': '立位-肩部90°屈曲',
        '48': '仰臥位',
        '49': '仰臥位',
        '50': '俯臥位',
        '51': '仰臥位',
        '52': '俯臥位',
        '53': '仰臥位',
        '54': '俯臥位',
        '55': '体幹',
        '56': '前方屈曲',
        '57': '左屈曲',
        '58': '右屈曲',
        '59': '座位',
        '60': '座位',
        '61': '座位',
        '62': '股関節部',
        '63': '左側',
        '64': '右側',
        '65': '前屈',
        '66': '後伸',
        '67': '内旋',
        '68': '外旋',
        '69': '内収',
        '70': '外展',
        '71': '立位',
        '72': '俯臥位',
        '73': '俯臥位-膝部90°屈曲',
        '74': '半俯臥位',
        '75': '立位',
        '76': '仰臥位',
        '77': '座位',
        '78': '座位',
        '79': '仰臥位',
        '80': '俯臥位',
        '81': '座位',
        '82': '仰臥位',
        '83': '俯臥位',
        '84': '仰臥位',
        '85': '仰臥位-膝部45°屈曲',
        '86': '仰臥位-肘部90°',
        '87': '仰臥位',
        '88': '仰臥位-膝部45°屈曲',
        '89': '仰臥位-肘部90°',
        '90': '横臥位',
        '91': '肘部',
        '92': '左側',
        '93': '右側',
        '94': '前屈',
        '95': '後伸',
        '96': '座位-肘部90°屈曲-腕関節中立位',
        '97': '座位-肘部90°屈曲-腕関節旋前',
        '98': '座位-肘部90°屈曲-腕関節旋後',
        '99': '座位-肘部90°屈曲・肩外展90°-腕関節中立位',
        '100': '座位-肘部90°屈曲・肩外展90°-腕関節旋前',
        '101': '立位-肘部90°屈曲-腕関節中立位',
        '102': '座位-肘部90°屈曲',
        '103': '腕部',
        '104': '左側',
        '105': '右側',
        '106': '旋後',
        '107': '旋前',
        '108': '前屈',
        '109': '後伸',
        '110': '尺側偏位',
        '111': '橈側偏位',
        '112': '肘部90°屈曲-腕関節中立位',
        '113': '肘部90°屈曲-腕関節中立位',
        '114': '肘部90°屈曲-腕関節中立位',
        '115': '肘部90°屈曲-腕関節中立位',
        '116': '肘部90°屈曲-腕関節中立位',
        '117': '肘部90°屈曲-腕関節旋前',
        '118': '肘部90°屈曲-腕関節旋後',
        '119': '肘部90°屈曲-腕関節中立位',
        '120': '肘部90°屈曲-腕関節旋前',
        '121': '肘部90°屈曲-腕関節旋後',
        '122': '手',
        '123': '左側',
        '124': '右側',
        '125': '握力',
        '126': '座位-肘部90°屈曲-腕関節中立位',
        '127': '座位-腕関節中立位',
        '128': '座位-肩部90°屈曲-腕関節中立位',
        '129': '膝部',
        '130': '左側',
        '131': '右側',
        '132': '屈曲',
        '133': '伸展',
        '134': '座位',
        '135': '俯臥位',
        '136': '仰臥位',
        '137': '座位-膝部90°屈曲',
        '138': '俯臥位-膝部90°屈曲',
        '139': '仰臥位',
        '140': '足首',
        '141': '左側',
        '142': '右側',
        '143': '内反',
        '144': '外反',
        '145': '背屈',
        '146': '跖屈',
        '147': '直脚座位',
        '148': '直脚座位',
        '149': '直脚座位',
        '150': '直脚座位',
        '151': '足',
        '152': '左側',
        '153': '右側',
        '154': '趾屈',
        '155': '趾伸',
        '156': '座位',
        '157': '直脚座位-跖屈',
        '158': '直脚座位-跖中立',
        '159': '座位',
        '160': '直脚座位-跖中立',
        '161': '直脚座位-跖屈',
        '162': '立位',
        '163': '仰臥位',
        '164': '立位',
        '165': '仰臥位',
        '166': '立位',
        '167': '仰臥位',
        '168': '立位',
        '169': '仰臥位',
        '170': '横臥位',
        '171': '横臥位',
        '172': '肩甲骨上挙',
        '173': '肩甲骨前進',
        '174': '肩甲骨後退',
        '175': '座位',
        '176': '座位',
        '177': '座位',
        '178': '座位-肘部90°屈曲',
        '179': '立位-肘部90°屈曲',
        '180': '仰臥位-肘部90°屈曲',
        '181': '座位-肘部90°屈曲',
        '182': '立位-肘部90°屈曲',
        '183': '俯臥位',
        '184': '座位-肩外展90°',
        '185': '座位-肩外展90°-肘部90°屈曲',
        '186': '座位-肘部90°屈曲',
        '187': '座位-肩外展90°-肘部90°屈曲',
        '188': '立位-肘部90°屈曲',
        '189': '横臥位-肘部90°屈曲',
        '190': '座位-肘部90°屈曲・肩外展90°・肩外旋90°',
        '191': '座位-肘部90°屈曲・肩外展90°・肩外旋90°',
        '192': '横臥位-肘部90°屈曲',
        '193': '立位-肘部90°屈曲-腕関節旋前',
        '194': '立位-肘部90°屈曲-腕関節旋後',
        '195': '立位-肘部90°屈曲',
        '197': 'その他',
        '198': '立位-膝部90°屈曲',
        '199': '座位-膝部45°屈曲',
        '200': '半仰臥位',
        '201': '俯臥位-膝部45°屈曲',
        '205': '大腿中部デッドリフト',
        '206': '立位',
        '207': '肘部90°屈曲-腕関節旋後',
        '208': '肘部90°屈曲-腕関節旋前',
        'Hip_Joint': '股関節',
        'Buckling': '屈曲',
        'Stand_Straight': '立位直脚',
        'Stand_Knees_Kick': '立位膝蹴り',
        'Stomach_Knees_30': '仰臥位膝部30°',
        'Sit_Knees_90': '座位膝部90°',
        'Back_Knees_90': '仰臥位膝部90°',
        'Spread': '伸展',
        'Stomach_Knees_Thigh': '仰臥位膝部90°-大腿後面',
        'Stand_Upright_Ankle': '立位直脚-足首',
        'Adduction_Abduction': '内収/外展',
        'Back_Knees_120': '仰臥位膝部120°',
        'Back_Knees_135': '仰臥位膝部135°',
        'Stance_Ankles': '立位-足首',
        'Standing_Knees': '立位-膝部',
        'Back_Ankles': '仰臥位-足首',
        'Back_Knees': '仰臥位-膝部',
        'Internal_External': '内旋/外旋',
        'Stomach_Knees_90': '仰臥位膝部90°',
        'Knee_Joint': '膝関節',
        'Stomach_Knees_45': '仰臥位膝部45°',
        'Stand_Knees_90': '立位膝部90°',
        'Back_Knees_45': '仰臥位膝部45°',
        'Sit_Knees_10': '座位膝部10°',
        'Sit_Knees_45': '座位膝部45°',
        'Back_Knees_10': '仰臥位膝部10°',
        'Ankle_Joint': '足首関節',
        'Dorsiflexion': '背屈',
        'Sitting_Position': '座位',
        'Varus_Valgus': '内反/外反',
        'Back_StraightLegs': '仰臥位直脚',
        'Toe_Flexion': '趾屈',
        'Lie_Supine': '仰臥位',
        'Shoulder_Joint': '肩関節',
        'Stomach_Straight': '仰臥位直臂',
        'Abduction': '外展',
        'Side_Straight': '横臥位-直臂',
        'Adduction': '内収',
        'Shoulder_Elbow': '仰臥位-肩外展90°肘屈曲90°',
        'Elbow_Neutral': '仰臥位-中立位肘屈曲90°',
        'Articulatio_Cubiti': '肘関節',
        'Sit_Elbows_90': '座位肘屈曲90°',
        'Neck': '颈部',
        'Default_Position': '默认姿势',
        'Lateral_Flexion': '側屈',
        'Other': 'その他',
        'Upper_Push': '上肢プッシュ',
        Default: '默认',
        Left: '左側',
        Right: '右側',
        Left_To_Right: '先左後右',
        Right_To_Left: '先右後左',
        simultaneously: '左右同時',
        Null: '無',
        'CMJ': 'カウンタージャンプ（下蹲跳）',
        'SJ': 'スクワットジャンプ（蹲跳）',
        'DropJump': 'ドロップジャンプ（跌落跳）',
        'MVC': '最大随意収縮',
        'RepetitiveHopping': '連続直脚跳び',
        'RepetitiveCMJ': '連続カウンタージャンプ',
        'Squat': 'スクワット（蹲起）',
        'Stamping': '踏みしめ運動（上下運動頻度と耐久力テスト）',
        'Landing': '着地テスト',
        'Balance': 'バランステスト（平衡テスト）',
        'AthleticShoulder': '肩関節テスト',
        'Free': 'フリーテスト（自由テスト）',
        'DJ': 'ドロップジャンプ（跳深）',
        'Inside': '内側',
        'Outside': '外側',
        '踝关节': '足首関節',
        '肘关节': '肘関節',
        '髋关节': '股関節',
        '颈部': '颈部',
        '肩关节': '肩関節',
        '躯干': '体幹',
        '膝关节': '膝関節',
        '腕关节': '腕関節',
        '腕关节尺偏': '腕関節尺側偏位',
        '髋关节外旋': '股関節外旋',
        '髋关节内收': '股関節内収',
        '髋关节外展': '股関節外展',
        '颈部屈曲': '颈部前屈',
        '颈部伸展': '颈部後伸',
        '颈部侧屈': '颈部側屈',
        '颈部旋转': '颈部回旋',
        '肩关节内旋': '肩関節内旋',
        '肩关节外旋': '肩関節外旋',
        '肩关节屈曲': '肩関節屈曲',
        '踝内翻': '足首内反',
        '踝外翻': '足首外反',
        '足背屈': '足背屈',
        '足跖屈': '足跖屈',
        '肘伸展': '肘関節伸展',
        '肘屈曲': '肘関節屈曲',
        '髋关节伸展': '股関節伸展',
        '髋关节屈曲': '股関節屈曲',
        '髋关节内旋': '股関節内旋',
        '肩关节外展': '肩関節外展',
        '躯干伸展': '体幹伸展',
        '躯干侧屈': '体幹側屈',
        '膝关节屈曲': '膝関節屈曲',
        '膝关节伸展': '膝関節伸展',
        '腕关节桡偏': '腕関節橈側偏位',
        '肩关节水平内收': '肩関節水平内収',
        '肩关节水平外展': '肩関節水平外展',
        '肩关节伸展': '肩関節伸展',
        '躯干屈曲': '体幹屈曲',
        '躯干旋转': '体幹回旋',
        '腕关节旋前': '腕関節旋前',
        '肩关节内收': '肩関節内収',
        '腕关节旋后': '腕関節旋後',
        '腕关节屈曲': '腕関節屈曲',
        '腕关节伸展': '腕関節伸展',
        '仰卧位': '仰臥位',
        '仰卧位（直腿）': '仰臥位（直脚）',
        '仰卧位（肘屈曲 90°）': '仰臥位（肘部90°屈曲）',
        '仰卧位（肩外展 90° - 肘屈曲 90°）': '仰臥位（肩外展90°-肘部90°屈曲）',
        '侧卧位': '横臥位',
        '俯卧位': '俯臥位',
        '俯卧位（肩外展 90° - 肘屈曲 90°）': '俯臥位（肩外展90°-肘部90°屈曲）',
        '半跪姿': '半跪姿',
        '坐位': '座位',
        '坐位（肘屈曲 90°）': '座位（肘部90°屈曲）',
        '坐位（肩外展 90° - 肘屈曲 90°）': '座位（肩外展90°-肘部90°屈曲）',
        '站立位': '立位',
        '站立位（肘屈曲 90°）': '立位（肘部90°屈曲）',
        '站立位（肩外展 90° - 肘屈曲 90°）': '立位（肩外展90°-肘部90°屈曲）',
        '肘屈曲90°': '肘部90°屈曲',
        '长坐位（无跖屈）': '長座位（跖屈なし）',
        '长坐位（跖屈）': '長座位（跖屈）',
        '动作模块': 'アクションモジュール',
        Wrist: '手首',
        Flexion: '屈曲',
        Extension: '伸展',
        Supination: '回外',
        Pronation: '回内',
        Ulnar_Deviation: '尺側偏位',
        Radial_Deviation: '橈側偏位',
        Wrist_Neutral: '肘90° - 手首中立位',
        Wrist_Supination: '肘90° - 手首回外',
        Wrist_Pronation: '肘90° - 手首回内'
    },
    StandardData: {
        Title: '標準値管理（携帯型筋力）',
        Assembly: '動作コンボ',
        Limbs: '体幹',
        Actions: '動作',
        Pose: '姿勢',
        Gender: '性別',
        Age: '年齢',
        PeakForce: 'ピーク力 N/kg',
        Modify: '標準値を設定',
        FileBrowsing: 'ファイル閲覧',
        FileRequired: 'インポートするファイルを選択してください',
        DropFileHere: 'ファイルをここにドラッグ',
        clickToUpload: 'クリックしてアップロード',
        SportTitle: '標準値管理（スポーツ機能表現）',
        Mean: '平均値',
        Outstanding: '優秀値',
        '青少年': '青少年',
        '18~30': '18～30',
        '31~45': '31～45',
        '46~60': '46～60',
        'AgeGroup': '年齢層',
        ModifySuccess: '修正に成功しました',
        ErrorRaw: 'エラー行',
        ErrorInfo: 'エラー情報',
        ErrorCount: 'エラー数',
        Sure: '確認',
        ErrorStatistics: 'エラー統計',
        EmptyId: 'IDは空欄にできません',
        IdParseError: 'IDが無効です',
        EmptyValue: '標準値は空欄にできません',
        InvalidId: 'IDが無効です',
        ValueParseError: '標準値が無効です',
    },
    Project: {
        Public: '公開',
        Private: '非公開',
        Title: 'テストプロジェクト',
        FilterName: 'プロジェクト名で検索',
        FilterSubject: '被験者名で検索',
        Columns: {
            CreateTime: '作成時間',
            ProjectName: 'プロジェクト名',
            CreatorName: '作成者名',
            Operate: '操作',
            Name: '氏名',
            Gender: '性別',
            Age: '年齢',
            SubjectName: '被験者名',
            Model: 'テスト動作',
        },
        RecordView: '記録',
        Batch: 'バッチ操作',
        BatchDelete: 'バッチ削除',
        DeleteEmptyNotice: '削除する内容を選択してください',
        Finish: '完了',
        Create: 'テストプロジェクトを作成',
        View: 'テストプロジェクト',
        ProjectName: 'プロジェクト名',
        Subjects: '被験者',
        AddSubject: '被験者を追加',
        PublicProject: '公開プロジェクト',
        PrivateProject: '非公開プロジェクト',
        ProjectType: 'プロジェクトタイプ',
        CreateTime: '作成時間',
        CreateProject: 'プロジェクトを作成',
        Save: '変更を保存',
        ProjectSubjectList: 'プロジェクト内被験者',
        NameFilter: '名前検索',
        CreateSuccess: '作成に成功しました',
        ModifySuccess: '修正に成功しました',
        DeleteSuccess: '削除に成功しました',
        DeleteFailed: '削除に失敗しました',
        NameTooLong: '名前が長すぎます。24文字以内で入力してください',
        RequireName: 'プロジェクト名を入力してください',
        SubjectManagerment: '被験者管理',
        Added: '追加済み',
        DeleteConfirm: 'プロジェクトを削除すると関連するテスト記録も一緒に削除されます。続けますか？',
        ConfirmToDeleteRow: 'このレコードを削除しますか？',
        ConfromToDeleteSubjetc: '被験者を削除すると関連するテスト記録も一緒に削除されます。続けますか？',
        DoNotAskAgain: 'これ以上表示しない',
    },
    TrainingPlan: {
        Title: '訓練計画',
        PlanType: 'タイプ',
        Public: '公開',
        Private: '非公開',
        PlanName: 'プラン名',
        Columns: {
            CreateTime: '作成時間',
            PlanName: '計画名',
            CreatorName: '作成者名',
            Operate: '操作',
            ActionCount: '動作数',
            Seq: '番号',
            Action: '動作',
            ActionTimes: '繰り返し回数',
            SubjectName: '被験者名',
            Completeness: '完了度',
            UsedTimes: 'テスト回数',
            Model: 'テスト動作',
            Gender: '性別',
        },
        Skipped: 'スキップ済み',
        RecordView: '記録',
        Batch: 'バッチ操作',
        BatchDelete: 'バッチ削除',
        Finish: '完了',
        Create: '訓練計画を作成',
        Modify: '修正',
        Actions: '動作',
        Subjects: '被験者',
        Records: 'テスト記録',
        Statue: '完了状態',
        Finished: '完了済み',
        Unfinish: '未完了',
        FilterName: '計画名で検索',
        RequireName: '計画名を入力してください',
        NameTooLong: '名前が長すぎます。50文字以内で入力してください',
        deleteRecord: '記録を削除',
        DeleteConfirm: '操作を実行すると関連するテスト記録も一緒に削除されます。続けますか？',
        AddAction: '動作を追加',
        TestActions: 'テスト動作',
        CreatePlan: '訓練計画を作成',
        SavePlan: '訓練計画を保存',
        Action: '動作',
        Times: '回数',
        ActionAssembly: '動作コンボ',
        RequireAssembly: '動作を選択してください',
        ConfirmDeleteAction: '動作を削除しますか？',
    },
    //运动表现标记信息
    '动作开始': 'アクション開始',
    '峰值': 'ピーク',
    '离地': '離地',
    '落地': '着地',
    '开始': '開始',
    '制动': '制動',
    '最低点': '最低点',
    '落地峰值': '着地ピーク',
    '动作结束': 'アクション終了',
    '跌落峰值': '落下ピーク',
    '蹬伸峰值': '伸展ピーク',
    '左侧最大力值': '左側最大力値',
    '右侧最大力值': '右側最大力値',
    '50ms': '50ms',
    '100ms': '100ms',
    '150ms': '150ms',
    '200ms': '200ms',
    '250ms': '250ms',
    '300ms': '300ms',
    'TFmin': 'TFmin',
    'T1': 'T1',
    'TStart': 'TStart',
    'TEnd': 'TEnd',
    'PO': 'PO',
    '触地': '接地',
    '稳定': '安定',
    '最大垂直力值': '最大垂直力値',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    '制动时刻': '制動時刻',
    '起跳时刻': '跳躍時刻',
    '蹬伸': '伸展',
    '结束': '終了',
    //错误信息
    DefaultGroup: 'デフォルトグループ',
    Empty_PhoneNumber: '携帯電話番号を入力してください',
    Duplicate_PhoneNumber: '携帯電話番号が重複しており、再びバインドできません',
    Invalid_BOMType: 'モジュールタイプが存在しません！',
    InsertFailed_Assembly: '動作の追加に失敗しました！',
    Invalid_BOM: 'モジュールが存在しません！',
    InsertFailed_BOM: 'モジュールの追加に失敗しました！',
    UpdateFailed_BOM: 'モジュールの更新に失敗しました！',
    DeleteFailed_BOM: 'モジュールの削除に失敗しました！',
    Invalid_Project: 'プロジェクトが存在しません！',
    Invalid_Subject: '被験者が存在しません！',
    Exsist_Account: 'アカウントが既に存在します！',
    Invalid_Account: 'アカウントが存在しません！',
    Incorrect_OldPassword: '古いパスワードが正しくありません！',
    Invalid_Company: '該当企業が見つかりません！',
    Invalid_CompanyID: '無効な企業コードです！',
    Incorrect_ApplicationCode: '無効なアプリコードです！',
    Incorrect_AccountOrPassword: 'ユーザー名またはパスワードが間違っています！',
    Expired_Captcha: '認証コードが期限切れです！',
    Incorrect_Captcha: '認証コードが間違っています！',
    Failed_SendCaptcha: '認証コードの送信に失敗しました！',
    Invalid_Captcha: '無効な認証コードです！',
    Empty_SubjectName: '被験者名を入力してください！',
    Repeat_SubjectName: '同名の被験者が既に存在します！',
    Duplicate_Requests: 'リクエストが過剰です。しばらく経ってから再試行してください',
    UnknownError_Account: '現在のユーザーが存在しません！',
    Locked_Company: '組織/企業がロックされています！',
    Expired_Authorization: '組織/企業のアプリケーション認証が期限切れです！',
    Invalid_Authorization: '組織/企業のアプリケーション認証が未契約です！',
    Invalid_Parameter: '無効なパラメータです！',
    Invalid_License: 'ライセンスが無効です！',
    Binded_License: 'ライセンスは他のデバイスにバインドされています！',
    Unbind_License: 'ライセンスは未バインドです！',
    Expired_License: 'ライセンスが期限切れです！',
    Failed_License: 'ライセンスの検証に失敗しました！',
    Empty_ApplictionCode: 'アプリケーション番号が欠落しています！',
    Invalid_ApplictionCode: '無効なアプリケーション番号です！',
    Invalid_ApplictionEndPoint: '無効なシステムノードです',
    Older_Version: '古いバージョン番号',
    Empty_Version: '有効なバージョン番号がありません',
    Duplicate_ApplicationCode: '重複したシステム識別コード',
    Invalid_Application: '無効なテストシステムです',
    Empty_Upgrade: '更新するファイルを選択してください',
    Invalid_Version: '無効なバージョン番号です',
    Invalid_Record: '無効なレコードです',
    NotFound_Record: 'データレコードが見つかりません',
    Failed_ResetPassword: 'パスワードリセットに失敗しました',
    Incomplete_Infomation: '入力情報が不完全です',
    Invalid_Binded: '無効なバインドレコードです',
    ParallelLimit_License: '最大バインド数を超えています',
    Exsist_PermissionGroup: '権限グループが既に存在します！',
    Invalid_PermissionDenied: '権限が不足しています',
    Invalid_PermissionGroup: '無効なロール権限です',
    Duplicate_Project: '重複したテストプロジェクト',
    Duplicate_SportProject: 'スポーツプロジェクト名は重複できません',
    Invalid_SportProject: '無効なスポーツプロジェクトです',
    Invalid_File: 'ファイルが存在しません！',
    UploadFailed_NoFile: 'アップロードするファイルがありません！',
    DownloadFailed_NoFile: 'ファイルが見つかりません！',
    Incorrect_Format: 'データ形式が正しくありません',
    UploadFailed_Timeout: 'アップロードがタイムアウトしました！',
    DownloadFailed_Timeout: 'ダウンロードがタイムアウトしました！',
    Repeat_Name: '同名のユーザーが既に存在します',
    Empty_Account: 'アカウントを入力してください',
    Empty_Password: 'パスワードを入力してください',
    Empty_Name: '氏名を入力してください',
    Invationing_SubjectEmail: 'このメールアドレスは招待中です',
    Invationing_SubjectName: '選手名は招待中です',
    Invalid_InvationLink: 'リンクは無効です',
    Submit_SubjectInfo: '選手は資料を提出しました',
    Incorrect_Subject: '選手が存在しません',
    Incomplete_InvationCode: '招待コードが欠落しています',
    Duplicate_Subject: '選手名が既に存在します',
    Duplicate_InvationEmail: '5分以内に同じメールアドレスに招待を送信できません',
    Invalid_RecordSide: '無効な順序です',
    NotBe_SameDay: '選択した日付は同じ日である必要があります',
    Invalid_Indicator: '無効な指標です',
    Invalid_UserName: 'ユーザーのニックネームは空欄にできません',
    UnUpload_SubjectOrProject: 'テスト項目または選手がアップロードされていません',
    UnUpload_Subject: '選手がアップロードされていません',
    Duplicate_SubjectName: '被験者名が重複しています',
    SyncData: 'まずデータを取得してください',
    Duplicate_TrainingPlanName: '重複した訓練計画名です',
    Invalid_TrainingPlan: '無効な訓練計画です',
    Invalid_Key: '無効なキー値です',
    Failed_CallService: 'サービス呼び出しに失敗しました',
    FileNotExist: 'ファイルが存在しません',
    Repeat_ProjectName: 'プロジェクト名が重複しています',
}